let UrlLogin: string;
let UrlHome: string;
let UrlHelp: string;
let UrlUnauthorized: string;
let UrlResourceAdmin: string;
let UrlUploadImgCarica: string;
let UrlErrorPage: string;
let UrlFilePickerDettagli: string;
let UrlFilePickerLista: string;
let UrlFilePickerSelectImg: string;

function noBack() {
    window.history.forward();
}

$(document).ajaxError(function (e, xhr, settings) {
    switch (xhr.status) {
        case 400:
            console.warn("Ajax Error 400");
            Controlli.Ajax.AjaxRedirectToAction(UrlHome);
            break;
        case 403:
            console.warn("Ajax Error 403");
            window.location.href = UrlUnauthorized;
            break;
        default:
            break;
    }
});

$(document).on("ready", function () {
    $(window).on("keydown", function (event) {
        if (event.key === "Enter") {
            if ($(event.target).hasClass("monaco-mouse-cursor-text")) {
                return true;
            } else {
                event.preventDefault();
                return false;
            }
        }
    });
});

$(document).on("keydown", ".input-group > input", function (event) {
    if (event.key === "Enter") {
        let btn = $(document).find(".input-group > .input-group-btn > button");
        btn.trigger('submit');
    }
});

$(document).on("click", "[data-menu-url]", function (obj) {
    obj.preventDefault();
    let _url: string = $(this).data("menu-url");

    Controlli.Utility.DestroyControl(Controlli.Utility.BodyName);
    Controlli.Ajax.AjaxLoadingHTML(_url);
    $(document).on(Controlli.Ajax.AjaxLoadingHTML_Done, () => Controlli.Ajax.UpdateURLAjax());
});

//Ajax Form Method
//OnBegin – xhr
//OnComplete – xhr, status
//OnSuccess – data, status, xhr
//OnFailure – xhr, status, error

namespace Controlli {
    export namespace Ajax {
        export let CurrentPageUrl: string;

        export const AjaxLoadingHTML_Done: string = "AjaxLoadingHTML_Done";

        export function AjaxLoadingHTML(url: string): void;
        export function AjaxLoadingHTML(url: string, selector: string): void;
        export function AjaxLoadingHTML(url: string, selector: string, data: any): void;
        export function AjaxLoadingHTML(url: string, selector?: string, data?: any): void;
        export function AjaxLoadingHTML(url: string, selector?: string, data?: any, isTraditional?: boolean): void;
        export function AjaxLoadingHTML(url: string, selector?: string, data?: any, isTraditional?: boolean, callback?: () => void);
        export function AjaxLoadingHTML(url: string, selector?: string, data?: any, isTraditional: boolean = true, callback?: () => void): void {
            if (selector == null) { selector = Utility.BodyName }

            if (selector != null && url != null) {
                let parentControl = $(selector);

                if (parentControl != null && parentControl != undefined) {
                    let ajaxSettings: JQueryAjaxSettings = {
                        dataType: "HTML",
                        url: url,
                        data: data,
                        type: "GET",
                        traditional: isTraditional,
                        cache: false,
                        async: true
                    }

                    parentControl.hide();
                    parentControl.html("");

                    let jqXhr: JQueryXHR = $.ajax(ajaxSettings);

                    jqXhr.done(function (partialViewResult) {
                        parentControl.html(partialViewResult);
                        Utility.RefreshControl(parentControl);
                        $(document).trigger(AjaxLoadingHTML_Done);

                        parentControl.fadeIn();

                        if (callback) {
                            callback();
                        }
                    });

                    jqXhr.fail(function () {
                        parentControl.html(jqXhr.responseText);
                    });
                }
            } else {
                alert("AjaxLoadingHTML: Parametri non definiti");
            }
        }

        export function AjaxGetHTML(url: string): string;
        export function AjaxGetHTML(url: string, data: any): string;
        export function AjaxGetHTML(url: string, data?: any): string {
            let _return: string;

            let ajaxSettings: JQueryAjaxSettings = {
                dataType: "HTML",
                url: url,
                data: data,
                traditional: true,
                type: "GET",
                cache: false,
                async: false
            }

            let jqXhr: JQueryXHR = $.ajax(ajaxSettings);

            jqXhr.done(function (partialViewResult) {
                _return = partialViewResult;
            });

            jqXhr.fail(function () {
                _return = jqXhr.responseText;
            });

            return _return;
        }

        export function AjaxPostHTML(url: string): string;
        export function AjaxPostHTML(url: string, data: any): string;
        export function AjaxPostHTML(url: string, data?: any): string;
        export function AjaxPostHTML(url: string, data?: any, isTraditional: boolean = true) {
            let _return: string;

            let ajaxSettings: JQueryAjaxSettings = {
                dataType: "HTML",
                url: url,
                data: data,
                traditional: isTraditional,
                type: "POST",
                cache: false,
                async: false
            }

            let jqXhr: JQueryXHR = $.ajax(ajaxSettings);

            jqXhr.done(function (partialViewResult) {
                _return = partialViewResult;
            });

            jqXhr.fail(function () {
                _return = jqXhr.responseText;
            });

            return _return;
        }

        export function AjaxGetJSON(url: string): JSON {
            let _return: JSON;

            let ajaxSettings: JQueryAjaxSettings = {
                dataType: "JSON",
                url: url,
                type: "GET",
                cache: false,
                async: false
            }

            let jqXhr: JQueryXHR = $.ajax(ajaxSettings);

            jqXhr.done(function (jsonResult) {
                _return = jsonResult;
            });

            jqXhr.fail(function () {
                _return = jqXhr.responseJSON;
            });

            return _return;
        }
        export function AjaxPostJSON(url: string, data?: any): JSON {
            let _return: JSON;

            let ajaxSettings: JQueryAjaxSettings = {
                dataType: "JSON",
                data: data,
                url: url,
                type: "POST",
                cache: false,
                async: false
            }

            let jqXhr: JQueryXHR = $.ajax(ajaxSettings);

            jqXhr.done(function (jsonResult) {
                _return = jsonResult;
            });

            jqXhr.fail(function () {
                _return = jqXhr.responseJSON;
            });

            return _return;
        }

        export function AjaxFormOnBegin(xhr: XMLHttpRequest) {
            let _this = $(this).find('button[type="submit"]');
            _this.html("<i class=\"fas fa-spinner fa-spin\"></i> Loading");
            _this.addClass("btn-dark");
            _this.prop("disabled", true);
        }
        export function AjaxFormOnComplete() {
            Utility.RefreshControl(Utility.BodyName);
        }
        export function AjaxFormOnSuccess() { /* document why this function 'AjaxFormOnSuccess' is empty */ }
        export function AjaxFormOnFailure() { /* document why this function 'AjaxFormOnSuccess' is empty */ }

        let _btnIdFormPartial: string;
        let _btnTextFormPartial: string;
        export function AjaxFormPartialOnBegin(btn: string, xhr: XMLHttpRequest) {
            let _this = $(`#${btn}`);
            _btnIdFormPartial = `#${btn}`;
            _btnTextFormPartial = _this.html();
            _this.html("<i class=\"fas fa-spinner fa-spin\"></i> Loading");
            _this.addClass("btn-dark");
            _this.prop("disabled", true);
        }
        export function AjaxFormPartialOnComplete(target: string) {
            let _this = $(_btnIdFormPartial);
            _this.html(_btnTextFormPartial);
            _this.removeClass("btn-dark");
            _this.prop("disabled", false);

            Utility.RefreshControl(`#${target}`);
        }
        export function AjaxFormPartialOnSuccess() { /* document why this function 'AjaxFormOnSuccess' is empty */ }
        export function AjaxFormPartialOnFailure() { /* document why this function 'AjaxFormOnSuccess' is empty */ }

        export function AjaxRedirectToAction(AjaxRedirectToActionURL: string) {

            let ajaxSettings: JQueryAjaxSettings = {
                dataType: "HTML",
                url: AjaxRedirectToActionURL,
                type: "GET",
                cache: false,
                async: true
            }

            let jqXhr: JQueryXHR = $.ajax(ajaxSettings);

            jqXhr.done(function (partialViewResult) {
                let parentControl = $(Utility.BodyName);
                parentControl.html(partialViewResult);
                Utility.RefreshControl(parentControl);
                UpdateURLAjax();
            });

            jqXhr.fail(function () {
                alert("errore");
            });
        }

        export function OpzioniAjaxActionLinkGETOnBegin() {
            //xxxx
            $(Utility.BodyName).hide();
            Utility.DestroyControl($(Utility.BodyName));
        }
        export function OpzioniAjaxActionLinkGETOnSuccess() {
            //xxxx
            UpdateURLAjax();
            Utility.RefreshControl($(Utility.BodyName));
            $(Utility.BodyName).fadeIn();
        }
        export function OpzioniAjaxActionLinkGETOnComplete() { /* document why this function 'AjaxFormOnSuccess' is empty */ }
        export function OpzioniAjaxActionLinkGETOnFailure() { /* document why this function 'AjaxFormOnSuccess' is empty */ }

        export function OpzioniAjaxActionConfirmGETOnBegin() { /* document why this function 'AjaxFormOnSuccess' is empty */ }
        export function OpzioniAjaxActionConfirmGETOnSuccess() { /* document why this function 'AjaxFormOnSuccess' is empty */ }
        export function OpzioniAjaxActionConfirmGETOnComplete() { /* document why this function 'AjaxFormOnSuccess' is empty */ }
        export function OpzioniAjaxActionConfirmGETOnFailure() { /* document why this function 'AjaxFormOnSuccess' is empty */ }

        export function UpdateURLAjax() {
            if (CurrentPageUrl != undefined) {
                window.history.pushState(null, "SAV", CurrentPageUrl);
            }
        }

        export class FormJsonResult {
            Stato: StatoForm;
            PartialView: string;
            Url: string;
            TargetID: string;
        }

        export enum StatoForm {
            Undefined,
            OK,
            OK_Apri,
            OK_Redirect,
            OK_RefreshBody,
            OK_RefreshTarget,
            OK_RefreshPartial,
            OK_Chiudi,
            Errore,
            Errore_Model,
        }
    }
}